import React, { useCallback, useEffect, useRef, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, Label, Tooltip } from "reactstrap";
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import { frequencyOwnerOptions,frequencyPropertyOptions, offPaymentTypeOptions } from "Enums/fixedData"
import Select from "react-select"
import CurrencyInput from 'react-currency-input-field';
import { useSelector } from "react-redux";
import ResaleService from "services/Provider/ResaleService";

const PaymentPlan = (props) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1
    const resaleService = new ResaleService
    const AuthData = useSelector(state => state.Auth)
    const [offPaymentOptions, setOffPaymentOptions] = useState([])
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    const { data, id, updateFormData, addNewRelease, loading } = props
    const [offPayment, setOffPayment] = useState(false)
    const [paymentAmount,setPaymentAmount] = useState()
    const [rend, setRend]= useState(false)
    const [change, setChange] = useState()
    const [error, setError] = useState({
        depost: false,
        total_price: false,
        remaining: false
    })
    const [formData, setFormData] = useState({
        total_price: "",
        payment_method: "",
        remaining_price: "",
        paid_price: "",
        original_price: "",
        until_month: "",
        until_year: "",
        recurring_payments: [],
        years: "",
        down_payment: "",
        payment_amount: "",
        payment_frequency: '',
        in_owner_installment: false,
        off_payments: [],
        depost: '',
        other_payment_name: ""
    });

    const handleFieldChange = (e) => {
        if (e.target.name === "payment_method") {
            changePaymentMethod(e.target.value)
        }
        setFormData((formData) => ({ ...formData, [e.target.name]: e.target.value }));
    }

    const getOptions = useCallback(
        (lang, list) => {
            return list.map(item => {
                return {
                    ...item,
                    label: item[`${lang}`]
                }
            })
        },
        [AuthData.lang],
    )
    useEffect(() => {
        if (formData) {
             updateFormData((data) => ({ ...data, ...formData }))
             if(formData?.off_payments.length > 0){
                setOffPayment(true)
             }
        }
        if(formData?.payment_plan?.payment_method === "Owner Installment"){
            if(formData?.payment_plan?.owner_installment?.off_payments?.length > 0){
                setOffPayment(true)
            }
        }
    }, [formData])

    useEffect(() => {
        if (id) {
             if (data.payment_plan.payment_method === "Cash") {
                setFormData({
                    ...formData,
                    payment_method: "Cash",
                    in_owner_installment: false,
                    depost: data.payment_plan.depost,
                    total_price: data.payment_plan.total_price
                })
            } else if (data.payment_plan.payment_method === "Installment") {
                setFormData({
                    ...formData,
                    payment_method: "Installment",
                    in_owner_installment: false,
                    years: data.payment_plan.years[0].years,
                    down_payment: data.payment_plan.years[0].down_payment,
                    payment_frequency: {
                        label: data.payment_plan.years[0].recurring_payments[0].payment_frequency,
                        value: data.payment_plan.years[0].recurring_payments[0].payment_frequency
                    },
                    payment_amount: data.payment_plan.years[0].recurring_payments[0].payment_amount,
                    total_price: data.payment_plan.total_price,
                    depost: data.payment_plan.depost,
                })
            } else {
                const loaadedData = data ?.payment_plan ?.owner_installment
                 setFormData({
                    ...formData,
                    payment_method: "Owner Installment",
                    in_owner_installment: true,
                    total_price: data.payment_plan.total_price,
                    remaining_price: loaadedData?.remaining_price,
                    paid_price: loaadedData ?.paid_price,
                    original_price: loaadedData ?.original_price ? loaadedData ?.original_price : "",
                    until_month: loaadedData ?.until_month,
                    until_year: loaadedData ?.until_year,
                    off_payments: loaadedData ?.off_payments ? loaadedData ?.off_payments : [],
                    payment_frequency: {
                        label : loaadedData?.recurring_payments[0]?.payment_frequency,
                        value: loaadedData?.recurring_payments[0]?.id
                    },
                    depost: data.payment_plan.depost,
                    recurring_payments: loaadedData ?.recurring_payments ? loaadedData ?.recurring_payments : []  
                })
                const options = offPaymentTypeOptions.filter(obj1 => !loaadedData?.off_payments.some(payment => payment.payment_name === obj1.label));
                // loaadedData?.off_payments?.map(payment=> {
                //     setOffPaymentOptions(offPaymentTypeOptions?.filter(item => item?.label !== payment?.payment_name))
                // })
                setOffPaymentOptions([...options])
                getPaid()
                if(loaadedData?.off_payments?.length > 0){
                    setOffPayment(true)
                }

            }
        }
        else {
            setFormData({ ...formData, ...data })
            setOffPaymentOptions(offPaymentTypeOptions)
        }
        setRend(!rend)
    }, [id])

    const changePaymentMethod = (type) => {
        setFormData((formData) => ({
            ...formData,
            remaining_price: "",
            paid_price: "",
            original_price: "",
            until_month: "",
            until_year: "",
            recurring_payments: type === "Owner Installment" ? [{ payment_frequency: "", payment_amount: "" }] : [],
            years: "",
            down_payment: "",
            payment_amount: "",
            payment_frequency: '',
        }))
    }

    const handleValidSubmit = async () => {
        if (formData.depost === "0" || !formData.depost || formData.depost === "") {
            setError({...error, depost: true})
            return
        }else if (formData.total_price === "0" || !formData.total_price || formData.total_price === "") {
            setError({...error, total_price: true})
            return
        } else {
            let info = {}
            if (formData.payment_method === "Installment") {
                if (formData.down_payment === "0" || !formData.down_payment || !formData.down_payment === "") {
                    toast.error("Down payment  field required &  doesn't accept zero")
                    return
                } else if (!formData.payment_frequency) {
                    toast.error("Payemnt frequency required")
                    return
                }  
                // } else if (parseInt(formData.down_payment) <= parseInt(formData.payment_amount)) {
                //     toast.error("Down payment must be bigger than payment ammout")
                //     return
                // } 
                else if (parseInt(formData.down_payment) >= parseFloat(formData.total_price)) {
                    toast.error("Total price must be bigger than down payment")
                    return
                }else if (parseInt(formData.down_payment) < parseFloat(formData.depost)) {
                    toast.error("Down Payment must be Bigger Than Deposit")
                    return
                }
                info = {
                    years: [
                        {
                            years: parseFloat(formData.years),
                            down_payment: parseFloat(formData.down_payment),
                            recurring_payments: [
                                {
                                    payment_frequency: formData.payment_frequency.label
                                }
                            ],
                        }
                    ],
                    owner_installment:{},
                    in_owner_installment: false,
                }
            } else if (formData.payment_method === "Owner Installment") {
                // if (formData.original_price !== "" && formData.original_price < 1) {
                //     toast.error("Original price  doesn't accept zero")
                //     return
                // } 
                if(formData.remaining_price === "" || !formData.remaining_price){
                    toast.error("Original Price Required")
                    return
                }
                if ( formData.remaining_price =='0') {
                    toast.error("Original Price doesn't accept zero")
                    return
                } else if (formData.recurring_payments.length && !validateRecurring()) {
                    return
                } else if (formData ?.off_payments ?.length && !validateOffPayment()) {
                    return
                } else if (parseFloat(formData.total_price) <= parseFloat(formData.paid_price)) {
                    toast.error("Total price must be bigger than down payment")
                    return
                } else if (formData.original_price === "0") {
                    toast.error(" original price does not accept zero")
                    return
                } else if(formData.off_payments.length > 0){
                    formData?.off_payments?.map((item, index)=>{
                        if(item.payment_fees > formData.remaining_price){
                            setError({...error, [index]: true})
                            return
                        }
                    })
                    let updatedOffPayments = formData?.off_payments?.map((item)=> {
                        if(item.payment_name === 'Other'){
                            return {
                                ...item,
                                payment_name: formData.other_payment_name
                            }
                        } 
                        return item
                    })
                    info={
                        in_owner_installment: true,
                        remaining_price: parseFloat(formData.remaining_price),
                        until_month: formData.until_month,
                        until_year: formData.until_year,
                        off_payments: updatedOffPayments,
                        recurring_payments: [
                            {
                                payment_frequency: formData.payment_frequency?.label
                            }
                        ]
                    }
                } else {
                    info = {
                        in_owner_installment: true,
                        remaining_price: parseFloat(formData.remaining_price),
                        until_month: formData.until_month,
                        until_year: formData.until_year,
                        off_payments: formData.off_payments,
                        recurring_payments: [
                            {
                                payment_frequency: formData.payment_frequency?.label
                            }
                        ]
                    }
                }
                

                if (formData.original_price !== undefined && formData.original_price !== "0" && formData.original_price !== "") {
                    info["original_price"] = formData.original_price
                } else {
                    info["original_price"] = ""

                }

            } else {
                info = { 
                    in_owner_installment: false,
                 }
            }
           addNewRelease({
                ...info, 
                total_price: parseFloat(formData.total_price),
                payment_method: formData.payment_method,
                depost: parseFloat(formData.depost)
           })
        }
    }

    const validateRecurring = () => {
        let result = true
        if (formData.recurring_payments.length !== 0) {
            formData.recurring_payments.forEach(item => {

                if (item?.payment_frequency?.label === "") {
                    toast.error(`Payment frequency  rquired  `)
                    result = false
                    return
                } else if (parseFloat(formData.total_price) <= parseFloat(item.payment_amount)) {
                    toast.error(`Total price must be bigger than payment amount `)
                    result = false
                    return
                }
                // } else if (parseFloat(item.payment_amount) >= parseFloat(formData.paid_price)) {
                //     toast.error(" Down Payment must be bigger than payment amount")
                //     result = false
                //     return
                // }
            })

        }
        return result
    }
    const validateOffPayment = () => {
        let result = true
        if (formData.off_payments.length !== 0) {
            formData.off_payments.forEach(item => {

                if (item.payment_fees === "0" || item.payment_fees === "" || !item.payment_fees) {
                    result = false
                    toast.error("Payment fees rquired  && doesnot accept zero")
                    return

                } else if (parseInt(item.payment_fees) >= parseInt(formData.total_price)) {
                    result = false
                    toast.error("Payment fees must be smaller than total price")
                    return
                }
            })

        }
        return result
    }
    const getPaid = () => {
        if (formData.total_price > 0 && formData.remaining_price > 0) {
            const res = parseInt(formData.total_price) - parseInt(formData.remaining_price)
            return res
        } else {
            return ""
        }
    }
    useEffect(() => {
        if (formData.total_price > 0 && formData.paid_price > 0) {
            setFormData({ ...formData, remaining_price: formData.total_price - formData.paid_price })
        }
    }, [formData.total_price, formData.paid_price]);

    const getRemaining = () => {
        if (formData.total_price > 0 && formData.down_payment> 0) {
            getPaymentAmount()
            return `${toCurrency(formData.total_price - formData.down_payment)} EGP`
        } else {
            return ""
        }
    }

    const getPaymentAmount= async () => {
        const dataObj = {
            years: formData?.years,
            total_price: formData?.total_price,
            down_payment: formData?.down_payment,
            payment_frequency: formData?.payment_frequency?.label}
            
        if (formData.total_price > 0 && 
            formData.down_payment> 0 && 
            formData.years && formData.payment_frequency?.label){
            const data = await resaleService?.getInstallmentRecurringPayment(dataObj, "sales-rep")
            const res = await data?.data
            
            setPaymentAmount(`${toCurrency(res)} EGP`)
        } else {
            return ""
        }
    }

    const getOwnerPaymentAmount= async (remaining_price) => {
        const dataObj = {
            until_month: formData.until_month,
            until_year: formData.until_year,
            total_price: formData.total_price,
            remaining_price: remaining_price,
            payment_frequency: formData.payment_frequency?.label
        }
       if (formData?.total_price > 0 && 
        formData?.remaining_price && 
        formData?.until_month && formData?.until_year &&
        formData?.until_year >= currentYear &&
        formData?.payment_frequency?.label !== 'One Shot' 
        ){
                resaleService?.getOwnerInstallmentRecurringPayment(dataObj, "sales-rep").then(res=>{
                    setPaymentAmount(`${toCurrency(res.data)} EGP`)
                }).catch(e => console.error(e))
        } else {
            return ""
        } 
    }

    const isMounted = useRef(false);
    useEffect(()=>{
        isMounted.current = true;
        if(formData.payment_method === "Owner Installment" && formData?.off_payments?.length === 0){
            getOwnerPaymentAmount(formData?.remaining_price)
        }
        if(formData.payment_method === "Owner Installment" && formData?.off_payments?.length > 0){
            if(formData?.off_payments?.length === 1 && parseInt(formData?.off_payments[0].payment_fees) < parseInt(formData.remaining_price)){
                setError({...error, remaining: false})
                let sumR= parseInt(formData?.remaining_price) - parseInt(formData?.off_payments[0].payment_fees)
                getOwnerPaymentAmount(sumR)
            
            } else{
                setError({...error, remaining: true})
            } 
            if (formData?.off_payments?.length > 1){
                let sum = formData?.off_payments?.reduce((a, b) =>  parseInt(a.payment_fees) + parseInt(b.payment_fees))
                if(parseInt(formData?.remaining_price) > sum){
                    setError({...error, remaining: false})
                    getOwnerPaymentAmount(parseInt(formData?.remaining_price) - sum)
                } else {
                    setError({...error, remaining: true})
                }
            }
        }
        return () => isMounted.current = false;
    }, [formData.total_price, formData.until_month, 
        formData.until_year, formData.remaining_price, 
        formData.payment_frequency?.label, formData?.off_payments[change]?.payment_fees])
    
    useEffect(() => {
        if (formData.total_price > 0 && formData.down_payment > 0 && formData.payment_method==="Installment") {
            getRemaining()
        }
    }, [formData.total_price, formData.down_payment]);

    const getOffPaymentAmount = async (dataObj) => {
        if (parseInt(dataObj.payment_fees) > 0 && 
             dataObj.end_month && dataObj.end_year&& 
             dataObj.month_number && dataObj.year_number && 
             dataObj.end_year >= dataObj.year_number &&
             dataObj.payment_frequency !== "One Shot"){
             
             const data = await resaleService?.getOffPayment(dataObj, "sales-rep")
             const res = await data?.data
             // setOffPaymentAmount([...offPaymentAmount, {[index]: res}])
             // offAmount.push({[index]: res})
             
             const updatedOffPayments = formData.off_payments?.map((offItem, offIndex) => {
                 if (dataObj.index === offIndex) {
                     return {
                         ...offItem,
                         payment_amount: res
                     }
                 }
                 return offItem
             })
             setFormData({ ...formData, off_payments: [...updatedOffPayments] })
         
         } else {
             return ""
         } 
     }

    useEffect(()=>{
        let offItem = formData?.off_payments[change]
        if(!!offItem
            && offItem?.month_number !=='' && !!offItem?.month_number
            && offItem?.year_number !== '' && !!offItem?.year_number
            && offItem?.end_month !== '' && !!offItem?.end_month
            && offItem?.end_year !== '' && !!offItem?.end_year
            && offItem?.payment_fees !== '' && !!offItem?.payment_fees
            && offItem?.payment_frequency !== '' && !!offItem?.payment_frequency
            && parseInt(offItem?.end_year) >= parseInt(offItem?.year_number)
            ){
                if(parseInt(offItem?.end_year) === parseInt(offItem?.year_number) 
                    && parseInt(offItem?.end_month) <= parseInt(offItem?.month_number)){
                    // toast.error('End Month must bigger than start Month') 
                } else{
                        getOffPaymentAmount({
                            index: change,
                            month_number: offItem?.month_number,
                            year_number: offItem?.year_number,
                            end_month: offItem?.end_month,
                            end_year: offItem?.end_year,
                            payment_fees: offItem?.payment_fees,
                            payment_frequency: offItem?.payment_frequency
                        })
                }
        }
        
    }, [rend])

    useEffect(()=>{
        if(formData?.off_payments.length > 0){
            setOffPayment(true)
        }
    }, [])

    useEffect(()=>{
        if(formData?.off_payments?.length === 1){
            let sumR= parseInt(formData?.remaining_price)+parseInt(formData?.off_payments[0].payment_fees)
            getOwnerPaymentAmount(sumR)
        
        } 
        if (formData?.off_payments?.length > 1){
            let sum = formData?.off_payments?.reduce((a, b) =>  parseInt(a.payment_fees) + parseInt(b.payment_fees))
            getOwnerPaymentAmount(parseInt(formData?.remaining_price)+parseInt(sum))
        }
    }, [rend])

    const calcMinMonthAndYear =() =>{
        if((!formData?.until_year || !formData?.until_month || formData?.until_year < currentYear)){
            return {month: 1, year: currentYear, monthError: 'This Field is Required', yearError: 'This Field is Required'}
        } else if(formData.payment_frequency.label === 'One Shot'){
            if(formData?.until_year == currentYear){
                if(currentMonth +1 > 11){
                    return {month:currentMonth+1 - 11, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than current Year'}
                } else {
                    return {month:currentMonth+1, year: currentYear, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than or Equal current Year'}
                }
            } else {
                if(currentMonth+1 > 11){
                    return {month:currentMonth+1 - 11, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than current Year'}
                } else {
                    return {month:1, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than or Equal current Year'}
                }
            }
        } else if(formData.payment_frequency.label === 'Monthly'){
            if(formData?.until_year == currentYear){
                if(currentMonth+2 > 11){
                    return {month:currentMonth+2 - 11, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than current Year'}
                } else {
                    return {month:currentMonth+2, year: currentYear, monthError: 'Month Must be bigger than current Month', yearError:  'Year Must be bigger than or Equal current Year'}
                }
            } else {
                if(currentMonth+2 > 11){
                    return {month:currentMonth+2 - 11, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than current Year'}
                } else {
                    return {month:1, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError:  'Year Must be bigger than or Equal current Year'}
                }
            }
        } else if(formData.payment_frequency.label === 'Quarterly'){
            if(formData?.until_year == currentYear){
                if(currentMonth+4 > 11){
                    return {month:currentMonth+4 - 11, year: currentYear +1, monthError: 'Month Must be bigger than Three Months ahead', yearError: 'Year Must be bigger than current Year'}
                } else {
                    return {month:currentMonth+4, year: currentYear, monthError: 'Month Must be bigger than Three Months ahead', yearError: 'Year Must be bigger than or Equal current Year'}
                }
            } else {
                if(currentMonth+4 > 11){
                    return {month:currentMonth+4 - 11, year: currentYear +1, monthError: 'Month Must be bigger than Three Months ahead', yearError: 'Year Must be bigger than current Year'}
                } else {
                    return {month:1, year: currentYear +1, monthError: 'Month Must be bigger than Three Months ahead', yearError: 'Year Must be bigger than or Equal current Year'}
                }
            }
        } else if(formData.payment_frequency.label === 'Semi-Annual'){
            if(formData?.until_year == currentYear){
                if(currentMonth+7 > 11){
                    return {month:currentMonth+7 - 11, year: currentYear +1, monthError: 'Month Must be bigger than Six Months ahead', yearError: 'Year Must be bigger than Current Year'}
                } else {
                    return {month:currentMonth+7, year: currentYear, monthError: 'Month Must be bigger than Six Months ahead', yearError: 'Year Must be bigger than or Equal Current Year'}
                }
            } else{
                if(currentMonth+7 > 11){
                    return {month:currentMonth+7 - 11, year: currentYear +1, monthError: 'Month Must be bigger than Six Months ahead', yearError: 'Year Must be bigger than Current Year'}
                } else {
                    return {month:1, year: currentYear, monthError: 'Month Must be bigger than Six Months ahead', yearError: 'Year Must be bigger than or Equal Current Year'}
                }
            }
        } else if(formData.payment_frequency.label === 'Annual' ){
            if(currentMonth+1 > 11){
                return {month:currentMonth+1 -11, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than current Year'}
            } else {
                return {month:currentMonth+1, year: currentYear +1, monthError: 'Month Must be bigger than current Month', yearError: 'Year Must be bigger than current Year'}
            }
        }
    }

    return (
        <AvForm onValidSubmit={(e, v) => { handleValidSubmit(e, v) }}>
            <Container>
                <Card>
                    <CardBody>
                        <Row>
                        <Col  md={8}>
                        <Label className="mt-2">Payment Method</Label>
                                <AvRadioGroup  inline name="payment_method" required 
                                    value={formData.payment_method} onChange={handleFieldChange} 
                                    errorMessage="This field is required" >
                                    <AvRadio label="Cash" value="Cash" />
                                    <AvRadio label="Installment with seller" value="Installment" />
                                    <AvRadio label="Completion Installment with Compound" value="Owner Installment" />
                                </AvRadioGroup>
                            </Col>
                            {formData.payment_method && <Col md={6} className="price-input mt-3"  >
                                <Label>Deposit</Label>
                                <CurrencyInput
                                    id="depost"
                                    className="mb-3"
                                    name={"depost"}
                                    placeholder={"Deposit"}
                                    value={formData.depost}
                                    allowNegativeValue={false}
                                    decimalsLimit={2}
                                    required
                                    onValueChange={(value) => {
                                        setFormData({ ...formData, depost: value })
                                        value && setError({...error, depost: false})
                                    }}
                                />
                                {error.depost && <p className="error-text">{"Deposit field required &  doesn't accept zero"}</p>}
                            </Col>}
                            {!!formData.depost && <Col md={6} className="price-input mt-3"  >
                                <Label>Total Price</Label>
                                <CurrencyInput
                                    id="price"
                                    className="mb-3"
                                    name={"total_price"}
                                    placeholder={"Price"}
                                    value={formData.total_price}
                                    allowNegativeValue={false}
                                    decimalsLimit={2}
                                    required
                                    onValueChange={(value, name) => {
                                        setFormData({ ...formData, total_price: value })
                                        value && setError({...error, total_price: false})
                                    }}
                                />
                                {error.total_price && <p className="error-text">{"Total Price field required &  doesn't accept zero"}</p>}
                            </Col>}
                  
                        {formData ?.payment_method === "Owner Installment" &&
                            <>
                                     {formData.total_price && <Col md={6} className="price-input"  >
                                        <Label>Origin Price (Optional)</Label>
                                        <CurrencyInput
                                            id="price"
                                            className="mb-3"
                                            name={"original_price"}
                                            placeholder={"Price"}
                                            value={formData.original_price}
                                            allowNegativeValue={false}
                                            decimalsLimit={2}
                                            onValueChange={(value, name) => {
                                                setFormData({ ...formData, original_price: value })
                                            }}
                                        />

                                    </Col>}
                                    
                                    {!!formData.total_price &&formData.total_price > 0 && <Col md={6} className="price-input"  >
                                        <Label>Remaining Price</Label>
                                        <CurrencyInput
                                            id="price"
                                            className="mb-3"
                                            name={"remaining_price"}
                                            placeholder={"Remaining Price"}
                                            value={formData.remaining_price}
                                            allowNegativeValue={false}
                                            decimalsLimit={2}
                                            required
                                            min='0'
                                            onValueChange={(value, name) => {
                                                setFormData({ ...formData, remaining_price: value })
                                            }}
                                        />
                                        {!!error?.remaining && <p className="error-text mb-3">{"Remaining Must be Bigger than the Total Payment Fees"}</p>}
                                    </Col>}

                                    {!!formData.remaining_price && formData.remaining_price > 0 && <Col md={6} className="price-input"  >
                                        <Label>Paid Price</Label>
                                        <CurrencyInput
                                            id="price"
                                            className="mb-3"
                                            name={"paid_price"}
                                            placeholder={" Paid Price"}
                                            value={getPaid()}
                                            allowNegativeValue={false}
                                            decimalsLimit={2}
                                            onValueChange={(value, name) => {
                                                setFormData({ ...formData, paid_price: value })
                                            }}
                                            readOnly
                                        />

                                    </Col> }
                                    {formData.remaining_price && formData.remaining_price > 0 && <>
                                        <Col md={6}>
                                            <label>Payment Frequency</label>
                                            <Select
                                                placeholder="select"
                                                name= 'payment_frequency'
                                                value={formData.payment_frequency}
                                                options={frequencyOwnerOptions}
                                                className='mb-3 '
                                                onChange={data => {
                                                    setFormData({ ...formData, payment_frequency: data })
                                                }}
                                            />
                                            </Col>
                                    </>}
                                    {formData.payment_frequency && <>
                                        <Col md={3}>
                                            <AvField
                                                errorMessage={calcMinMonthAndYear()?.monthError}
                                                name={"until_month"}
                                                label={formData.payment_frequency.label === 'One Shot' ? "Month" : "Until Month"}
                                                bsSize="lg"
                                                required
                                                value={formData.until_month}
                                                step="1"
                                                pattern="\d+"
                                                type="number"
                                                min={calcMinMonthAndYear().month}
                                                max={"12"}
                                                onChange={e => {
                                                    setFormData({ ...formData, until_month: e.target.value })
                                                }}
                                                placeholder={formData.payment_frequency.label === 'One Shot' ? "Month" : "Until Month"}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <AvField
                                                errorMessage={calcMinMonthAndYear()?.yearError}
                                                className="mb-3"
                                                name={"until_year"}
                                                label={formData.payment_frequency.label === 'One Shot' ? "Year" : "Until Year"}
                                                bsSize="lg"
                                                required
                                                value={formData.until_year}
                                                onChange={e => {
                                                    setFormData({ ...formData, until_year: e.target.value })
                                                    }}
                                                placeholder="e.g. 2026"
                                                type="number"
                                                step="1"
                                                pattern="\d+"
                                                min={calcMinMonthAndYear().year}
                                                max={new Date().getFullYear() + 30}
                                            />
                                        </Col>
                                        </>   
                                    }
                                    {   formData.payment_frequency?.label !== 'One Shot' && 
                                        !!formData?.recurring_payments && 
                                        !!formData.until_year && formData.until_year >= currentYear &&
                                        !!formData.until_month &&<>
                                    <Col md={6} className="price-input"  >
                                    <Label>Payment Amount for unit
                                        <i className="fa ms-2 fa-question-circle" id="DisabledAutoHideExample"></i>
                                        <Tooltip
                                            placement="bottom"
                                            isOpen={tooltipOpen}
                                            autohide={false}
                                            target="DisabledAutoHideExample"
                                            toggle={toggle}
                                        >
                                            This field displays the amount paid for unit installments only based on the selected Payment Frequency, and the value in the field will decrease in each addition of another payment plan type
                                        </Tooltip>
                                    </Label>
                                    <AvField
                                        id={`payment_amount`}
                                        className="mb-3"
                                        name={`Payment Amount`}
                                        placeholder="Payment Amount"
                                        value={paymentAmount}
                                        readOnly
                                    />
                                    </Col>
                                    </>
                                    }

                                    {formData.payment_frequency && <Row className="m-0 p-0 box-container  box-width">
                                        <Col md={6} className="my-4 overflow-hidden" ><h5 className="m-0">Is a Payment Plan has Another Type</h5></Col>
                                        <Col md={6} className="d-flex flex-row-reverse overflow-hidden">
                                            <div className='form-check form-switch form-switch-md mt-3'>
                                                <AvField
                                                    name='in_compound'
                                                    checked={offPayment}
                                                    value={offPayment}
                                                    type='checkbox'
                                                    className='form-check-input '
                                                    id='has_status'
                                                    onChange={e => {
                                                        setOffPayment(e.target.checked)
                                                        if(e.target.checked && formData.off_payments.length === 0){
                                                            setFormData({ ...formData, off_payments: [{
                                                                payment_name: "",
                                                                payment_fees: "",
                                                                year_number: "",
                                                                month_number: ""
                                                                }] 
                                                            })
                                                        }
                                                        if(e.target.checked === false){
                                                            setFormData({ ...formData, off_payments: [] })
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>}

                                    {offPayment ? formData?.off_payments?.map((offItem, offParentIndex) => {
                       const selectOptions = getOptions(AuthData.lang, [...offPaymentOptions, {
                        label: "Other",
                        en:"Other",
                        ar:"اخرى",
                        zh:"其他",
                        ru:"Другой",
                        value: "Other"
                    }])
                       const frequencySelectOptions = getOptions(AuthData.lang, frequencyOwnerOptions)
                        return (
                            <Row className="my-3 m-auto py-2 bg-light" key={offParentIndex}>
                                <Col md={offParentIndex === 0 ? 12 : 6} className="my-2"><h5> 
                                {offParentIndex+1}{offParentIndex+1 === 1 && 'st'}{offParentIndex+1 === 2 && 'nd'}{offParentIndex+1 === 3 && 'rd'}{offParentIndex+1 >3 && 'th'} Payment Plan Type
                                    </h5></Col>
                                {offParentIndex > 0 && <Col md={6} className="d-flex justify-content-end my-2">
                                    <button
                                        className="btn btn-light"
                                        type="button"
                                        onClick={() => {
                                            const updatedOffPayments = formData.off_payments.filter((_, index) => index !== offParentIndex)
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                        }}
                                        style={{ color: "red", fontWeight: "700" }}
                                    >X</button></Col>}
                                <Col md={6} >
                                <label>Payment Name*</label>
                                    <Select
                                        className="mb-3"
                                        placeholder="Select"
                                        options={selectOptions}
                                        value={!!selectOptions[selectOptions.findIndex(item=>item.value==offItem?.payment_name)] ? selectOptions[selectOptions.findIndex(item=>item.value==offItem?.payment_name)]: !!offItem?.payment_name ? {label: offItem?.payment_name, value: offItem?.payment_name} : null}
                                        onChange={e => {
                                            const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                if (offParentIndex === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        payment_name: e.value
                                                    }
                                                }
                                                
                                                return offItem
                                            })
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                            setOffPaymentOptions(offPaymentOptions.filter(option=> e.value !== option.value))
                                        }}
                                        required
                                    />
                                </Col>
                                {offItem?.payment_name === 'Other' && <Col md={6} >
                                    <label>Name*</label>
                                    <AvField
                                        errorMessage={"this field is required"}
                                        className="mb-3"
                                        name='payment_name'
                                        bsSize="lg"
                                        value={formData.other_payment_name}
                                        onBlur={e => setFormData({ ...formData, other_payment_name: e.target.value })}
                                        required
                                        type="text"
                                        placeholder={"Payment Name"}
                                    />
                                </Col>}
                                <Col className="price-input" md={6} >
                                <Label className={`${(error[offParentIndex] &&'error-text')}`}> Payment Fees*</Label>
                                    <CurrencyInput
                                        id={`Payment fees`}
                                        errorMessage={"this field is required"}
                                        className={`${error[offParentIndex]? 'mb-0' : 'mb-3'}`}
                                        name={`Payment fees`}
                                        placeholder={"Payment Fees"}
                                        value={offItem.payment_fees}
                                        min='0'
                                        max={formData.remaining_price}
                                        allowNegativeValue={false}
                                        decimalsLimit={2}
                                        required
                                        onValueChange={(value, name) => {
                                            setRend(!rend)
                                            setChange(offParentIndex)
                                            const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                if (offParentIndex === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        payment_fees: value
                                                    }
                                                }
                                                return offItem
                                            })
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                            if(parseInt(value) >= parseInt(formData.remaining_price)){
                                                setError({...error,[offParentIndex]: true})
                                            } else {
                                                setError({...error,[offParentIndex]: false})
                                            }
                                        }}
                                    />
                                    {error[offParentIndex] && <p className="error-text mb-3"> Must be Smaller than the Remaining Price </p>}
                                </Col>
                                <Col md={6} >
                                <label>Payment Frequency*</label>
                                    <Select
                                        className="mb-3"
                                        name={`payment_frequency${offParentIndex}`}
                                        placeholder={"Select"}
                                        options={frequencySelectOptions}
                                        value={offItem.payment_frequency ? frequencySelectOptions[frequencySelectOptions.findIndex(item=>item.value==offItem.payment_frequency)] : null}
                                        onChange={e => {
                                            setRend(!rend)
                                            setChange(offParentIndex)
                                            const value = e.value
                                            const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                if (offParentIndex === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        payment_frequency: value
                                                    }
                                                }
                                                return offItem
                                            })
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                        }}
                                        required
                                    />
                                </Col>
                                <Col md={3} >
                                    <AvField
                                        errorMessage={parseInt(offItem.year_number) === new Date().getFullYear() ? "Month must be greater than current Month" : "this field is required"}
                                        className="mb-3"
                                        name={`month_number${offParentIndex}`}
                                        label={offItem.payment_frequency === 'One Shot' ? "Month" : "Start Month"}
                                        bsSize="lg"
                                        value={offItem.month_number}
                                        onChange={e => {
                                            setRend(!rend)
                                            setChange(offParentIndex)
                                            const value = e.target.value
                                            const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                if (offParentIndex === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        month_number: value
                                                    }
                                                }
                                                return offItem
                                            })
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                        }}
                                        required
                                        type="number"
                                        step="1"
                                        pattern="\d+"
                                        placeholder={"Month Number"}
                                        min={offItem.payment_frequency === 'One Shot' && parseInt(offItem.year_number) === currentYear ? currentMonth +2 : '1'}
                                        max="12"
                                    />
                                </Col>
                                <Col md={3} >
                                    <AvField
                                        errorMessage={"this field is required"}
                                        className="mb-3"
                                        label= {offItem.payment_frequency === 'One Shot' ? "Year" : "Start Year"}
                                        name={`year_number${offParentIndex}`}
                                        bsSize="lg"
                                        value={offItem.year_number}
                                        onChange={e => {
                                            setRend(!rend)
                                            setChange(offParentIndex)
                                            const value = e.target.value
                                            const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                if (offParentIndex === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        year_number: value
                                                    }
                                                }
                                                return offItem
                                            })
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                        }}
                                        required
                                        type="number"
                                        step="1"
                                        pattern="\d+"
                                        placeholder={"Year Number"}
                                        min={currentYear}
                                        max={currentYear + 30}
                                    />
                                </Col>
                                {!!offItem.payment_frequency && offItem.payment_frequency !== 'One Shot' && <>
                                <Col md={3} className="mb-3">
                                    <AvField
                                        errorMessage={parseInt(offItem.year_number) === parseInt(offItem.end_year) ? "Month must be greater than current Month" : "this field is required"}
                                        name={`end_month${offParentIndex}`}
                                        label="End Month"
                                        bsSize="lg"
                                        value={offItem.end_month}
                                        onChange={e => {
                                            setRend(!rend)
                                            setChange(offParentIndex)
                                            const value = e.target.value
                                            const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                if (offParentIndex === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        end_month: value
                                                    }
                                                }
                                                return offItem
                                            })
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                        }}
                                        required
                                        type="number"
                                        step="1"
                                        pattern="\d+"
                                        placeholder={"Month Number"}
                                        min={parseInt(offItem.year_number) === parseInt(offItem.end_year) ? new Date().getMonth() +2 : '1'}
                                        max="12"
                                    />
                                </Col>
                                <Col md={3} className="mb-3">
                                    <AvField
                                        errorMessage={parseInt(offItem.end_year) === currentYear ? "Year must be greater than current Year" : "this field is required"}
                                        label={"End Year"}
                                        name={`end_year${offParentIndex}`}
                                        bsSize="lg"
                                        value={offItem.end_year}
                                        onChange={e => {
                                            setRend(!rend)
                                            setChange(offParentIndex)
                                            const value = e.target.value
                                            const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                                if (offParentIndex === offIndex) {
                                                    return {
                                                        ...offItem,
                                                        end_year: value
                                                    }
                                                }
                                                return offItem
                                            })
                                            setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                        }}
                                        required
                                        type="number"
                                        step="1"
                                        pattern="\d+"
                                        placeholder={"End Year"}
                                        min={currentYear}
                                        max={currentYear +30}
                                    />
                                </Col>
                                {offItem.end_year && offItem.end_month && 
                                offItem.year_number && offItem.month_number  
                                && offItem.end_year >= offItem.year_number && <Col md={6} className="price-input" >
                                    <Label>{`Payment Amount (${offItem.payment_name})`}</Label>
                                    <CurrencyInput
                                        id={`Payment Amount (${offItem.payment_name})`}
                                        className="mb-3"
                                        name={`Payment Amount (${offItem.payment_name})`}
                                        value={offItem.payment_amount}
                                        allowNegativeValue={false}
                                        decimalsLimit={2}
                                        readOnly
                                    />
                                </Col>}
                                </>}
                            </Row>
                        )
                    })
                        : null}
                               {offPayment &&   <Row>
                                    <Col className="d-flex flex-row-reverse mt-4 mx-2">
                                        <Button
                                            onClick={() => {
                                                setFormData({
                                                    ...formData, off_payments: [...formData.off_payments, {
                                                        payment_name: "",
                                                        payment_fees: "",
                                                        year_number: "",
                                                        month_number: ""
                                                    }]
                                                })
                                            }}> Add Another Payment Type</Button>
                                    </Col>
                                </Row>}
                            </>
                        }
                        {formData ?.payment_method === "Installment" &&
                            <Row>
                               {formData.total_price &&
                                <Col md={6} className="price-input" >
                                <Label>Down Payment*</Label>
                                <CurrencyInput
                                    id={`down_payment`}
                                    className="mb-3"
                                    name={`down_payment`}
                                    placeholder={"Down Payment"}
                                    value={formData.down_payment}
                                    allowNegativeValue={false}
                                    decimalsLimit={2}
                                    required
                                    onValueChange={(value) => {
                                        setFormData({ ...formData, down_payment: value })
                                    }}
                                />
                            </Col>} 
                                    { formData.down_payment && <Col md={6} >
                                    <AvField
                                        className="mb-3"
                                        name={`years`}
                                        label={`Years Of Installment*`}
                                        bsSize="lg"
                                        value={formData.years}
                                        onChange={e => handleFieldChange(e)}
                                        required
                                        placeholder={"Years 1-30"}
                                        min="1"
                                        type="number"
                                        max="30"
                                        errorMessage="This field is required"
                                    />
                                </Col>}
                                { formData.down_payment && <Col md={6}>
                                    <label>Payment Frequency*</label>
                                    <Select
                                        placeholder={"Select"}
                                        value={formData.payment_frequency}
                                        options={frequencyPropertyOptions}
                                        className='mb-3 '
                                        onChange={data => {
                                            setFormData({ ...formData, payment_frequency: data })
                                        }}
                                    />
                                </Col>}
                                {!!formData.years && !!formData.payment_frequency?.label
                                && formData.total_price > 0 && formData.down_payment > 0 &&  <>
                                    <Col md={6}>
                                        <AvField
                                            className="mb-3"
                                            name={"Remaining Price"}
                                            label="Remaining Price"
                                            bsSize="lg"
                                            required
                                            value={getRemaining()}
                                            placeholder="Remaining Price"
                                            type="text"
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={6} className="price-input" >
                                    <Label>Payment Amount*</Label>
                                    <AvField
                                        id={`payment_amount`}
                                        className="mb-3"
                                        name={`Payment Amount`}
                                        placeholder={"Payment Amount"}
                                        value={paymentAmount}
                                        disabled={true}
                                    />
                                </Col>
                                </>}
                               
                            </Row>
                        }
                    </Row>
                    </CardBody>
                </Card>
                {props.children}
            </Container>
        </AvForm >
    )
}
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}
export default PaymentPlan